// 提交 mutations是更改Vuex状态的唯一合法方法
// export const modifyAName = (state, name) => { // A组件点击更改餐馆名称为 A餐馆
// 	localStorage.setItem('name', JSON.stringify(name))
//     state.resturantName = name // 把方法传递过来的参数，赋值给state中的resturantName
// }
export const ChangeProductName = (state, name) => { 
    localStorage.setItem('name', JSON.stringify(name))
    state.productname = name
}
export const ChangeProductlist = (state, prpductnewlist) => {
    localStorage.setItem('prpductnewlist', JSON.stringify(prpductnewlist))
    state.productlist = prpductnewlist
}
export const ChangeYwwpicRight = (state,newYwwpicRight) => {
    localStorage.setItem('newYwwpicRight', JSON.stringify(newYwwpicRight))
    state.YwwpicRight = newYwwpicRight
}
export const ChangeYwwLagre = (state,newYwwLagre) => {
    localStorage.setItem('newYwwLagre', JSON.stringify(newYwwLagre))
    state.YwwLagre = newYwwLagre
}
export const ChangeXiancai= (state, newXiancai) => {
    localStorage.setItem('newXiancai', JSON.stringify(newXiancai))
    state.Xiancai = newXiancai
}
export const ChangeBaozhuang = (state, newBaozhaung) => {
    localStorage.setItem('newBaozhaung', JSON.stringify(newBaozhaung))
    state.Baozhuang = newBaozhaung
}
export const ChangeDesginList = (state, newDesginList) => {
    localStorage.setItem('newDesginList', JSON.stringify(newDesginList))
    state.DesginList = newDesginList
}
export const ChangeSum = (state, newsum) => {
    localStorage.setItem('newsum', JSON.stringify(newsum))
    state.sum = newsum
}
export const ChangePnumber = (state, newPnumber) => {
    localStorage.setItem('newPnumber', JSON.stringify(newPnumber))
    state.Pnumber = newPnumber
}
export const ChangeAllsum = (state, newAllSum) => {
    localStorage.setItem('newAllSum', JSON.stringify(newAllSum))
    state.AllSum = newAllSum
}
export const ChangeSelectDesign = (state, newSelectDesign) => {
    localStorage.setItem('newSelectDesign', JSON.stringify(newSelectDesign))
    state.SelectDesign = newSelectDesign
}
export const ChangeCustomUplod = (state, newCustomUplod) => {
    localStorage.setItem('newCustomUplod', JSON.stringify(newCustomUplod))
    state.CustomUplod = newCustomUplod
}
export const Changelogostylenumber = (state, newlogostylenumber) => {
    localStorage.setItem('newlogostylenumber', JSON.stringify(newlogostylenumber))
    state.logostylenumber = newlogostylenumber
}
export const ChangelogoColornumber = (state, newlogoColornumber) => {
    localStorage.setItem('newlogoColornumber', JSON.stringify(newlogoColornumber))  
    state.logoColornumber = newlogoColornumber
}
export const ChangeSumPrice = (state, newSumPrice) => {
    localStorage.setItem('newSumPrice', JSON.stringify(newSumPrice))
    state.SumPrice = newSumPrice
}
export const ChangeDesignMake = (state, newDesignMake) => {
    localStorage.setItem('newDesignMake', JSON.stringify(newDesignMake))
    state.DesignMake = newDesignMake
}
export const ChangeChildproductlist = (state, newChildproductlist) => {
    localStorage.setItem('newChildproductlist', JSON.stringify(newChildproductlist))
    state.Childproductlist = newChildproductlist
    // this.$store.dispatch('getWorkCount');
}
export const Changeaddinfo = (state, newaddinfo) => {
    localStorage.setItem('newaddinfo', JSON.stringify(newaddinfo))
    state.Changeaddinfo = newaddinfo
    // this.$store.dispatch('getWorkCount');
}
export const ChangetabbarList = (state, newtabbarList) => {
    localStorage.setItem('newtabbarList', JSON.stringify(newtabbarList))
    state.ChangetabbarList = newtabbarList
    // this.$store.dispatch('getWorkCount');
}
export const Changetokenid = (state, newtokenid) => {
    localStorage.setItem('newtokenid', JSON.stringify(newtokenid))
    state.Changetokenid = newtokenid
    // this.$store.dispatch('getWorkCount');
}
export const Changeukey = (state, newukey) => {
    localStorage.setItem('newukey', JSON.stringify(newukey))
    state.Changeukey = newukey
    // this.$store.dispatch('getWorkCount');
}
export const Changemakelist = (state, newmakelist) => {
    sessionStorage.setItem('newmakelist', JSON.stringify(newmakelist))
    state.Changemakelist = newmakelist
    // this.$store.dispatch('getWorkCount');
}



// WEBPACK FOOTER //
// ./src/store/mutations.js